import { useSelector } from "react-redux";
import DashboardCard from "shared/DashboardCard";
import DonationSearchBar from "shared/DonationSearchBar";

const Details = () => {
  const { transactionsCount, walletAmount } = useSelector(
    (state) => state.transaction
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4 max-[450px]:flex-wrap">
        <DashboardCard
          className="rounded-lg !w-[250px]"
          title="Total Transaction"
          completedProjects={transactionsCount}
          paragraph="since January"
          textColor="text-white"
          paragraphColor="text-[#F0CA18]"
          bgColor="bg-[#011F56]"
          percentage="+0%"
        />
        <DashboardCard
          className="rounded-lg !w-[250px] !bg-[#fafafafa]"
          title="Cash Credits"
          amount={walletAmount}
          paragraph="recent credits"
          paragraphColor="#0ABD06"
          bgColor="bg-white"
          percentage={transactionsCount}
        />
      </div>
      <DonationSearchBar
        searchText="Search Transactions"
        param="Transactions"
      />
    </div>
  );
};

export default Details;
